// 正则相关
import Vue from 'vue'

export const Patterns = {
  phoneNo: /^1[0-9]{10}$/, // 手机号码
  telNo: /^(([0+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/, // 座机号码
  idCardNo: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/, // 身份证号码
  passport: /^[a-z0-9]+$/i, // 护照
  hongkongPass: /^(M|H|m|h)(\d{8,10})$/, //  '港澳居民来往内地通行证',
  taiwanPass: /^(\d{8}|\d{10})$/, //  '台湾居民来往大陆通行证'
  name: /^[\u4e00-\u9fa5·]{2,20}$/, // 中文名
  nameEnglish: /^[a-zA-Z·]{2,}$/, // 英文名,
  nameEngCn: /^[\u4e00-\u9fa5a-zA-Z·]{2,}$/, // 中英文混着
  emoji: /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|[<>~@#$%^&*()_\-+=<\\|/]/, // 表情和特殊字符
  numToFixed2: /^\d+(\.\d{2})?$/,
  pwd: /^\d{4,12}$/
}

Vue.prototype.$patterns = Patterns
